<template>
  <v-app
    dark
    style="background: #4da7af;
    background: -webkit-linear-gradient(to right, #4da7af, #a8c0b1);
    background: linear-gradient(to right, #4da7af, #a8c0b1);"
  >
    <v-content>
      <!-- MAIN SCREEN -->
      <v-expand-x-transition>
        <div v-show="expandMain">
          <v-container>
            <v-card elevation="15" style="background: #221f20" dark>
              <v-card-title>
                <v-layout row child-flex justify-center align-center wrap>
                  <v-flex xs6 md4 class="px-4 text-xs-center">
                    <img src="./assets/logo-col.png" alt="AltaVista" style="width:100%" />
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text>
                <carousel :per-page="1" :autoplay="true" :loop="true" :autoplayTimeout="4000" :paginationEnabled="false">
                  <slide><div class="avcar"><img src="./assets/imgs/rot01.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot02.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot03.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot04.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot05.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot06.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot07.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot08.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot09.jpg"></div></slide>
                  <slide><div class="avcar"><img src="./assets/imgs/rot10.jpg"></div></slide>
                </carousel>
                <v-layout row child-flex wrap class="mt-1 px-4 text-xs-center">
                  <v-flex>
                    <h3>Departamentos totalmente equipados para estadías diarias, semanales, mensuales y anuales</h3>
                  </v-flex>
                </v-layout>
                <v-layout row child-flex wrap class="mt-4 text-xs-center">
                  <!-- ABOUT -->
                  <v-flex xs12 md3 class="px-4 mb-3">
                    <h3>
                    <a href="#" v-on:click.stop.prevent="cambiar('about')">
                      Sobre Alta Vista
                      <v-icon right>contact_support</v-icon>
                    </a>
                    </h3>
                  </v-flex>
                  <!-- CONTACT -->
                  <v-flex xs12 md3 class="px-4 mb-3">
                    <h2>Contactos</h2>
                    <img class="avicon" src="./assets/imgs/phone-icn.png" alt="teléfono" />
                    <img class="avicon" src="./assets/imgs/whatsapp-icn.png" alt="whatsapp" />
                    <h3><a href="tel:3482599696">(3482) 59 96 96</a></h3>
                  </v-flex>
                  <!-- SOCIAL -->
                  <v-flex xs12 md3 class="px-4 mb-3">
                    <h2>Redes Sociales</h2>
                    <a href="https://web.whatsapp.com/" target="_blank">
                      <img class="avicon" src="./assets/imgs/whatsapp-icn.png" alt="whatsapp" />
                    </a>
                    <a href="https://www.instagram.com/altavistareconquista/" target="_blank">
                      <img class="avicon" src="./assets/imgs/instagram-icn.png" alt="whatsapp" />
                    </a>
                    <a href="https://www.facebook.com/altavistaapartboutique" target="_blank">
                      <img class="avicon" src="./assets/imgs/facebook-icn.png" alt="whatsapp" />
                    </a>
                  </v-flex>
                  <!-- CONTACT FORM BUTTON -->
                  <v-flex xs12 md3 class="px-4 mb-3 text-xs-right">
                    <v-btn class="success mx-0 mt-3" @click="cambiar('form')">
                      Solicitar Reserva
                      <v-icon right>check_circle</v-icon>
                    </v-btn><br />
                    <h2>
                    <a href="https://www.google.com/maps/dir//Dr.+Jos%C3%A9+de+Amenabar+1140,+S3560ASX+Reconquista,+Santa+Fe/@-29.1480528,-59.657654,17z/data=!4m17!1m7!3m6!1s0x944eba9e1114eb85:0xbb2b653dc891fc89!2sDr.+Jos%C3%A9+de+Amenabar+1140,+S3560ASX+Reconquista,+Santa+Fe!3b1!8m2!3d-29.1480528!4d-59.6554653!4m8!1m0!1m5!1m1!1s0x944eba9e1114eb85:0xbb2b653dc891fc89!2m2!1d-59.6554653!2d-29.1480528!3e2" target="_blank">
                      <img class="avicon" src="./assets/imgs/location-icn.png" alt="whatsapp" />
                      Cómo llego?
                    </a>
                    </h2>

                  </v-flex>
                </v-layout>

                <!-- Footer Info -->
                <v-layout row wrap class="px-4 mt-4 text-xs-center">
                  <v-flex xs12 md4>Amenabar 1140 Reconquista - Santa Fe</v-flex>
                  <v-flex xs12 md4>reservasaltavista.reconquista@gmail.com</v-flex>
                  <v-flex xs12 md4>www.altavistaapart.com.ar</v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </div>
      </v-expand-x-transition>

      <!-- ABOUT SCREEN -->
      <v-expand-x-transition>
        <div v-show="expandAbout">
          <v-container>
            <v-card dark
              elevation="15"
              style="background: #3A1C71;
                background: -webkit-linear-gradient(to right, #324B4D, #00737B);
                background: linear-gradient(to right, #324B4D, #00737B);"
                >
              <v-card-title>
                <v-layout row child-flex justify-center align-center wrap>
                  <v-flex xs6 md4 class="px-4 text-xs-center">
                    <img src="./assets/logo-byn.png" alt="AltaVista" style="width:100%" />
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text>
                <v-layout row child-flex wrap class="mt-1 px-4 text-xs-center">
                  <v-flex xs12 md12 class="px-4 text-xs-center">
                    <h4>
                    Le damos la mas cordial bienvenida a ALTA VISTA Apart Boutique, la fusión perfecta entre hotel y hogar.
                    Nuestros modernos departamentos, fueron concebidos para brindarle una experiencia de alto nivel en alojamiento,
                    donde el confort se encuentra presente en todos los ambientes.
                    Nuestros departamentos, de 1 y 2 dormitorios, cuentan con cocina completa, lavadero con lavarropas automático,
                    living comedor con vistas a la ciudad, gran cuarto de baño y cochera cerrada, vigilada por circuito de videocámaras.
                    <br />
                    Disponemos de tarifas corporativas y de cliente frecuente.<br />
                    <br />
                    Aguardamos su consulta o reserva, en el teléfono <a href="tel:3482599696">3482 599696</a>, o por email en: <a href="mailto:reservasaltavista.reconquista@gmail.com">reservasaltavista.reconquista@gmail.com</a>.
                    </h4>
                  </v-flex>
                    <v-flex xs12 md6 class="px-4 text-xs-right">
                      <v-btn class="success mx-0 mt-3" @click="cambiar('main')">
                        Volver
                        <v-icon right>replay</v-icon>
                      </v-btn>
                    </v-flex>
                </v-layout>

                <!-- Footer Info -->
                <v-layout row wrap class="px-4 mt-4 text-xs-center">
                  <v-flex xs12 md4>Amenabar 1140 Reconquista - Santa Fe</v-flex>
                  <v-flex xs12 md4>reservasaltavista.reconquista@gmail.com</v-flex>
                  <v-flex xs12 md4>www.altavistaapart.com.ar</v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </div>
      </v-expand-x-transition>

      <!-- FORMULARIO -->
      <v-expand-x-transition>
        <div v-show="expandForm">
          <v-container>
            <v-card dark
              elevation="15"
              style="background: #3A1C71;
            background: -webkit-linear-gradient(to right, #324B4D, #00737B);
            background: linear-gradient(to right, #324B4D, #00737B);"
            >
              <v-card-title>
                <v-layout row child-flex justify-center align-center wrap>
                  <v-flex xs6 md4 class="px-4 text-xs-center">
                    <img src="./assets/logo-byn.png" alt="AltaVista" style="width:100%" />
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text>
                <v-form class="px-6" ref="form">
                  <v-layout row wrap>
                    <v-flex xs12 md6 class="px-4">
                      <v-menu
                        v-model="date1"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateArrive"
                            label="Fecha de llegada"
                            hint="DD/MM/YYYY"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="arrive"
                          no-title
                          @input="date1 = false"
                          locale="es-ar"
                        ></v-date-picker>
                      </v-menu>
                      <!-- p>Date (ISO format): <strong>{{ arrive }}</strong></p -->
                    </v-flex>

                    <v-flex xs12 md6 class="px-4">
                      <v-menu
                        v-model="date2"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateLeave"
                            label="Fecha de partida"
                            hint="DD/MM/YYYY"
                            persistent-hint
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="leave"
                          no-title
                          @input="date2 = false"
                          locale="es-ar"
                        ></v-date-picker>
                      </v-menu>
                      <!-- p>Date in ISO format: <strong>{{ leave }}</strong></p -->
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md3 class="px-4 mt-3">
                      <v-icon>people</v-icon>Cantidad de huéspedes:
                      <span style="font-size: 2rem">{{hosts}}</span>
                    </v-flex>
                    <v-flex xs12 md9 class="px-4 mt-1">
                      <v-rating
                        v-model="hosts"
                        length="6"
                        min="1"
                        max="6"
                        empty-icon="person_outline"
                        full-icon="person"
                        half-icon="people"
                        color="primary"
                        background-color="success"
                        size="40"
                      ></v-rating>
                    </v-flex>
                  </v-layout>

                  <v-flex xs12 class="px-4">
                    <v-text-field
                      v-model="fullname"
                      label="Apellido y Nombre"
                      prepend-icon="person"
                      :rules="[inputRules.min8]"
                    ></v-text-field>
                  </v-flex>

                  <v-layout row wrap>
                    <v-flex xs12 md5 class="px-4">
                      <v-text-field
                        v-model="phone"
                        label="Teléfono"
                        prepend-icon="phone"
                        :rules="[inputRules.phone]"
                        type="tel"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md7 class="px-4">
                      <v-text-field
                        v-model="email"
                        label="E-Mail"
                        prepend-icon="email"
                        :rules="[inputRules.email]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 class="px-4">
                      <v-btn class="success mx-0 mt-3" @click="submit" :loading="sendLoading">
                        Enviar
                        <v-icon right>send</v-icon>
                      </v-btn>
                      {{ menssage }}
                    </v-flex>
                    <v-flex xs12 md6 class="px-4 text-xs-right">
                      <v-btn class="success mx-0 mt-3" @click="cambiar('main')">
                        Volver
                        <v-icon right>replay</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
                <!-- Footer Info -->
                <v-layout row wrap class="px-4 mt-4 text-xs-center">
                  <v-flex xs12 md4>Amenabar 1140 Reconquista - Santa Fe</v-flex>
                  <v-flex xs12 md4>reservasaltavista.reconquista@gmail.com</v-flex>
                  <v-flex xs12 md4>www.altavistaapart.com.ar</v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </div>
      </v-expand-x-transition>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios"
import { Carousel, Slide } from 'vue-carousel'

export default {
  components: {
    Carousel,
    Slide
  },
  name: "App",
  data: ()=>({
    message:"",
    fullname: "",
    phone: "",
    email: "",
    arrive: new Date().toISOString().substr(0, 10),
    leave: new Date().toISOString().substr(0, 10),
    hosts: 1,
    date1: false,
    date2: false,
    sendLoading: false,
    expandForm: false,
    expandMain: true,
    expandAbout: false,
    inputRules: {
      min3: v => v.length >= 3 || "Longitud mínima es de 3 caracteres.",
      min8: v => v.length >= 8 || "Longitud mínima es de 8 caracteres.",
      required: v => !!v || "No Válido",
      email: v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || "e-mail No Válido.";
      },
      phone: v => {
        const pattern = /^(?:(?:00)?549?)?0?(?:11|[2368]\d)(?:(?=\d{0,2}15)\d{2})??\d{8}$/;
        return pattern.test(v) || "Teléfono No Válido.";
      }
    }
  }),
  methods: {
    submit(e) {
      e.preventDefault();

      if (this.$refs.form.validate()) {
        this.sendLoading = true;
        axios
          .post("sendmail-api.php", {
            arrive: this.arrive,
            leave: this.leave,
            hosts: this.hosts,
            fullname: this.fullname,
            phone: this.phone,
            email: this.email
          })
          .then(response => {
            this.message=response;
            //this.dialog = false;
            //this.popSnack('success', 'Usuario agregado. ' + response.data);
            //this.$refs.form.reset(); // hace referencia al 'ref' del v-form llamado "form"
            //alert(response);
          })
          .catch(error => {
            this.message=error;
            //this.popSnack('error', error);
            //this.dialog = true;
            //alert("Error:" + error);
          })
          .finally(() => (this.sendLoading = false));
      }
    },
    cambiar(sect) {
      switch(sect){
        case 'main':
          this.expandForm=false;
          this.expandMain=true;
          this.expandAbout=false;
          break;
        case 'form':
          this.expandForm=true;
          this.expandMain=false;
          this.expandAbout=false;
          break;
        case 'about':
          this.expandForm=false;
          this.expandMain=false;
          this.expandAbout=true;
          break;
      }
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }
  },
  computed: {
    dateArrive() {
      return this.formatDate(this.arrive);
    },
    dateLeave() {
      return this.formatDate(this.leave);
    }
  },
};
</script>

<style>
* {
  font-family: "Quicksand", sans-serif;
  touch-action: manipulation;
}

html {
  font-size: calc(1em - 0.3vw);
}

a{
  text-decoration: none;
}
a:hover img {
  filter: drop-shadow(0px 0px 0.75rem lime) saturate(8);
}

h1 {
  font-size: 1.8rem;
  font-weight: normal;
}

h2 {
  font-size: 1.6rem;
  font-weight: normal;
}

h3 {
  font-size: 1.4rem;
  font-weight: normal;
}

h4 {
  font-size: 1.2rem;
  font-weight: normal;
}

.avcar {
  align-items: center;
  display: flex;
  justify-content: center;
  max-height: 30rem;
}

img {
  width: 100%;
}

.avicon {
  width: 8%;
  min-width: 20px;
  max-width: 40px;
  margin: 3px;
  vertical-align: middle;
}
</style>
